import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';

import { Button, OnCloseConfirmationModal } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import CreateCrewSettlementModal from '@/shared/components/molecules/CreateSettlement/CreateCrewSettlementModal';
import CreateWorkerSettlementModal from '@/shared/components/molecules/CreateSettlement/CreateWorkerSettlementModal';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import CreateSettlementIcon from '~/images/shared/createSettlementIcon.svg';

interface Props {
  endDate: Date | null;
  startDate: Date | null;
}

const CreateSettlement: React.FC<Props> = ({ endDate, startDate }) => {
  const { openModal } = useModal();
  const { t } = useTranslation('common');
  const [store] = useStore((store) => store);
  const isDemoFarm = store?.isDemoFarm;
  const selectedAsset = store?.asset;
  const settlementLevel = selectedAsset?.settlementLevel;

  const handleCreateSettlementClick = useCallback(() => {
    if (isDemoFarm) {
      openModal(<DemoCTA />, {
        title: t('create-settlement'),
      });
    } else if (settlementLevel === 2) {
      openModal(
        <CreateWorkerSettlementModal endDate={endDate} startDate={startDate} />,
        {
          title: t('create-settlement'),
          variant: 'full',
          onClose: () => openModal(<OnCloseConfirmationModal />),
        }
      );
    } else {
      openModal(
        <CreateCrewSettlementModal endDate={endDate} startDate={startDate} />,
        {
          title: t('create-settlement'),
          variant: 'full',
          onClose: () => openModal(<OnCloseConfirmationModal />),
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, selectedAsset?.id, settlementLevel]);

  return (
    <Button
      onClick={handleCreateSettlementClick}
      className='flex items-center justify-around !rounded-xl'
    >
      <>
        <BaseIcon size='sm'>
          <CreateSettlementIcon />
        </BaseIcon>

        {t('new-settlement')}
      </>
    </Button>
  );
};
export default CreateSettlement;
